import {
  Sheet as ShadSheet,
  SheetContent as ShadSheetContent,
  SheetHeader as ShadSheetHeader,
  SheetTitle as ShadSheetTitle,
} from "@/components/ui/sheet"
import Button from "@/components/button"
import Bottombar from "@/components/bottombar"
import { Icon } from "@/icons/icon"
import { cn } from "@/lib/utils"

export type ConfirmActionSheetProps = {
  open: boolean
  title?: string
  description?: string
  confirmLabel?: string
  loading?: boolean
  onClose?: () => void
  onClickConfirm?: () => void | Promise<void>
  onClickBack?: () => void | Promise<void>
}

export default function ConfirmActionSheet({
  open,
  title = "Submit Sheet",
  confirmLabel = "Confirm",
  loading = false,
  description = "Are you sure you want to submit ? You won’t be able to edit any readings later",
  onClose,
  onClickConfirm,
  onClickBack,
}: ConfirmActionSheetProps) {
  async function handleConfirm() {
    if (onClickConfirm) {
      await onClickConfirm()
    }
  }

  function handleOpenChange(open: boolean) {
    if (!open && onClose) {
      onClose()
    }
  }

  return (
    <ShadSheet open={open} onOpenChange={handleOpenChange}>
      <ShadSheetContent
        side="bottom"
        className="shadow-drop-shadow mx-auto rounded-t-lg"
      >
        <ShadSheetHeader className="pb-0 sticky top-0 bg-white">
          <ShadSheetTitle className="text-xl font-semibold flex flex-col gap-5">
            <div className="h-13 w-13 flex items-center justify-center rounded-full bg-backdrop">
              <Icon name="History" className="h-6 w-auto" />
            </div>

            <div>{title}</div>
          </ShadSheetTitle>
        </ShadSheetHeader>

        <div className="font-normal pt-4 px-4 py-4">{description}</div>

        <Bottombar className={cn("flex gap-4 bg-white sticky bottom-0")}>
          <Button variant="outline" onClick={onClickBack} disabled={loading}>
            Back
          </Button>
          <Button className="flex-1" variant="default" onClick={handleConfirm} disabled={loading}>
            {loading ? "Processing..." : confirmLabel}
          </Button>
        </Bottombar>
      </ShadSheetContent>
    </ShadSheet>
  )
}
